
define('tpl!taoQtiItem/qtiXmlRenderer/tpl/responses/rule_choices', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n<responseCondition>\n    <responseIf>\n        <match>\n            <variable identifier=\"";
  if (helper = helpers.response) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.response); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.multiple), {hash:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </match>\n        <setOutcomeValue identifier=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1.outcome)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n            <baseValue baseType=\"identifier\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1.then)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</baseValue>\n        </setOutcomeValue>\n    </responseIf>";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1['else']), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</responseCondition>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            <multiple>\n                ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.choices), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </multiple>\n            ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "";
  buffer += "\n                <baseValue baseType=\"identifier\">"
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "</baseValue>\n                ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <baseValue baseType=\"identifier\">";
  if (helper = helpers.choice) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.choice); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</baseValue>\n            ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <responseElse>\n        <setOutcomeValue identifier=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1.outcome)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n            <baseValue baseType=\"identifier\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.feedback)),stack1 == null || stack1 === false ? stack1 : stack1['else'])),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</baseValue>\n        </setOutcomeValue>\n    </responseElse>";
  return buffer;
  }

  stack1 = helpers.unless.call(depth0, (depth0 && depth0.noData), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  });
});

